/**
 * Traduz uma falha de requisição (erro do axios) numa frase para o usuário.
 *
 * Existe por causa do incidente de 28/09/2026 (precatorios_web#9): sem
 * resposta do servidor o login mostrava "Undefined error" e a lista ficava
 * carregando para sempre, sem o usuário saber o que estava acontecendo.
 *
 * Exemplo:
 *   try { await api.get('/process/search/'); }
 *   catch (error) { showToast('error', describeApiError(error)); }
 */

export const MSG_TIMEOUT =
    'O servidor demorou demais para responder. Tente novamente em instantes.';
export const MSG_SEM_RESPOSTA =
    'Não foi possível falar com o servidor. Verifique sua conexão ou tente novamente em instantes.';
export const MSG_INESPERADA = 'Ocorreu um erro inesperado. Tente novamente.';

const TIMEOUT_CODES = ['ECONNABORTED', 'ETIMEDOUT'];

const firstText = (value) => {
    if (typeof value === 'string') return value;
    if (Array.isArray(value) && typeof value[0] === 'string') return value[0];
    return null;
};

// Mensagem que o backend Django/DRF devolveu, se houver: {error}, {detail} ou
// o primeiro campo com texto (ex.: {non_field_errors: [...]}).
const backendMessage = (data) => {
    if (!data || typeof data !== 'object') return null;
    const preferred = firstText(data.error) || firstText(data.detail);
    if (preferred) return preferred;
    return Object.values(data).map(firstText).find(Boolean) || null;
};

const describeHttpError = ({ status, data }) => {
    const message = backendMessage(data);
    if (message) return message;
    if (status >= 500) {
        return `O servidor está instável no momento (erro ${status}). Tente novamente em instantes.`;
    }
    return `Não foi possível concluir a operação (erro ${status}).`;
};

export const describeApiError = (error) => {
    if (!error) return MSG_INESPERADA;
    if (error.response) return describeHttpError(error.response);
    if (TIMEOUT_CODES.includes(error.code)) return MSG_TIMEOUT;
    if (error.request) return MSG_SEM_RESPOSTA;
    return MSG_INESPERADA;
};
